import { ChangeDetectionStrategy, Component } from '@angular/core';


import {
    FieldType
} from '../../../../../core/field-definitions/entities/field-definition.entity';
import { ShComplexMapInputFieldComponent } from '../complex-map-input-field/complex-map-input-field.component';

@Component({
    standalone: false,
    selector: 'sh-complex-field',
    templateUrl: '../complex-map-input-field/complex-map-input-field.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShComplexInputFieldComponent extends ShComplexMapInputFieldComponent {
    protected type: FieldType = FieldType.ComplexField;

    // Temporarily treating this like a ComplexMapField
    // Technically for a ComplexField, every key can have multiple values
}
